import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/ui.css';
import './styles/list-page.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import coldtubFavicon from './assets/logos/coldtub.png';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');
const root = ReactDOM.createRoot(rootElement);

window.matchMedia('(prefers-color-scheme: dark)').addEventListener("change", function (e) {
  e.matches ? document.body.setAttribute('data-theme', 'dark') : document.body.setAttribute('data-theme', 'light');
});

// at this point, there is nothing paint on screen yet.
(function() { try {
    var mode = localStorage.getItem('data-theme');
    if (mode) {
      document.body.setAttribute('data-theme', mode);

    } else if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      document.body.setAttribute('data-theme', 'dark');
    }

  } catch (e) {} })();

// Set brand based on hostname (localStorage override for local dev)
(function() {
  var brand = localStorage.getItem('data-brand');
  var isColdTub = brand ? brand === 'coldtub' : window.location.hostname.includes('mycoldtub');
  if (brand) {
    document.body.setAttribute('data-brand', brand);
  } else if (isColdTub) {
    document.body.setAttribute('data-brand', 'coldtub');
  }
  if (isColdTub) {
    document.title = 'My COLDTUB™';
    var icon = document.querySelector("link[rel='icon']") as HTMLLinkElement | null;
    if (!icon) {
      icon = document.createElement('link');
      icon.rel = 'icon';
      document.head.appendChild(icon);
    }
    icon.type = 'image/png';
    icon.href = coldtubFavicon;
    var appleIcon = document.querySelector("link[rel='apple-touch-icon']") as HTMLLinkElement | null;
    if (appleIcon) appleIcon.href = coldtubFavicon;
  }
})();

root.render(
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();